import { render, staticRenderFns } from "./AdvancedOptions.vue?vue&type=template&id=33add48a&scoped=true"
import script from "./AdvancedOptions.vue?vue&type=script&lang=js"
export * from "./AdvancedOptions.vue?vue&type=script&lang=js"
import style0 from "./AdvancedOptions.vue?vue&type=style&index=0&id=33add48a&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33add48a",
  null
  
)

export default component.exports